module.exports = __webpack_public_path__ + "img/trading_license.6991f3ba.png";